import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { Toaster } from "@/components/ui/sonner";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import Home from "@/pages/Home";
import ServiceDetail from "@/pages/ServiceDetail";
import CustomerDashboard from "@/pages/CustomerDashboard";
import PartnerDashboard from "@/pages/PartnerDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import PaymentSuccess from "@/pages/PaymentSuccess";
import PaymentCancel from "@/pages/PaymentCancel";
import Favorites from "@/pages/Favorites";
import MapView from "@/pages/MapView";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/angebot/:id" element={<ServiceDetail />} />
          <Route path="/karte" element={<MapView />} />
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/cancel" element={<PaymentCancel />} />
          <Route path="/meine-buchungen" element={<ProtectedRoute><CustomerDashboard /></ProtectedRoute>} />
          <Route path="/favoriten" element={<ProtectedRoute><Favorites /></ProtectedRoute>} />
          <Route path="/partner" element={<ProtectedRoute roles={["partner", "admin"]}><PartnerDashboard /></ProtectedRoute>} />
          <Route path="/admin" element={<ProtectedRoute roles={["admin"]}><AdminDashboard /></ProtectedRoute>} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
